
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import NutritionIcon from '../../../assets/images/icons/nutrition.svg?inline';
import ItemTags from '@/components/shared/ItemTags.vue';

const namespace: string = 'filters';

@Component<ItemInformation>({ components: { NutritionIcon, ItemTags } })
export default class ItemInformation extends Vue {
	@Getter('getDiets', { namespace }) private dietOptions!: any[];
	@Getter('getAllergens', { namespace }) private allergenOptions!: any[];
	@Getter('hidePricing', { namespace: 'restaurant' }) private hidePricing!: boolean;
	@Getter('isGenericCatering', { namespace: 'cart' }) private isGenericCatering!: boolean;
	@Getter('isViewOnly', { namespace: 'cart' }) private isViewOnly!: boolean;
	@Prop({ type: Object, required: true, default: () => {} }) private menuItem!: MenuItem;
	@Prop({ type: Number, required: false }) private displayCalories!: number;

	/**
	 * Get the allergens values
	 *
	 * @return {string[]}
	 */
	private get allergens(): string[] {
		let allergens: string[] = [];
		if (this.menuItem.allergens) {
			allergens = this.menuItem.allergens.toLowerCase().replace(/(_|-)/gi,' ').split(',');
			allergens = allergens.map((allergen: any) => {
				const allergenObject = this.allergenOptions.find((allergenOption: any) => allergen === allergenOption.value.toLowerCase());
				return allergenObject ? allergenObject.itemLabel.toLowerCase() : allergen;
			});
		}
		return allergens;
	}

	/**
	 * Get the dietary values
	 *
	 * @return {string[]}
	 */
	private get diets(): string[] {
		let diets: string[] = [];
		if (this.menuItem.diets) {
			diets = this.menuItem.diets.toLowerCase().replace(/(_|-)/gi,' ').split(',');
			diets = diets.map((diet: any) => {
				const dietObject = this.dietOptions.find((dietOption: any) => diet === dietOption.value.toLowerCase() );
				return dietObject ? dietObject.itemLabel.toLowerCase() : diet;
			});
		}
		return diets;
	}

	private get isPriceOnRequest(): boolean {
		return !!(this.menuItem.price_on_request && (this.isGenericCatering || this.isViewOnly));
	}
}
